/**
 * Service availability switch.
 *
 * When `SERVICE_PAUSED` is true every page that depends on the backend
 * (unlock / seller / dashboard / download) renders `ServicePausedNotice`
 * instead of its normal UI, and the auth layer skips all network calls.
 * Static brand pages (home, skills, guides, support, terms) are unaffected.
 *
 * To resume service: set `NEXT_PUBLIC_SERVICE_PAUSED=false` in the
 * Cloudflare Pages environment (or flip the default below) and redeploy.
 * The API client is untouched, so nothing else needs to change.
 */
const envValue = process.env.NEXT_PUBLIC_SERVICE_PAUSED;

export const SERVICE_PAUSED: boolean =
  envValue === undefined || envValue === "" ? true : envValue === "true";

export const SUPPORT_EMAIL = "support@govilo.xyz";
